import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  progress: number;
  threshold?: number;
}

export function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
  progress,
  threshold = 80,
}: PullToRefreshIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null;

  return (
    <div
      className="absolute left-0 right-0 flex items-center justify-center z-10 pointer-events-none transition-all"
      style={{
        top: 0,
        height: pullDistance,
        opacity: Math.min(progress * 2, 1),
      }}
    >
      <div
        className={cn(
          "flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 border border-primary/20",
          isRefreshing && "animate-pulse"
        )}
      >
        <RefreshCw
          className={cn(
            "h-5 w-5 text-primary transition-transform",
            isRefreshing && "animate-spin"
          )}
          style={{
            transform: isRefreshing
              ? undefined
              : `rotate(${progress * 360}deg)`,
          }}
        />
      </div>
    </div>
  );
}
